module.exports = __webpack_public_path__ + "static/media/profile-lars-anthonisen.769addc6.png";